import { useTranslation } from "react-i18next";
import axios from "axios";
import { useContext, useEffect, useState } from "react";
import { AuthContext } from "../../context/AuthContext";
import Loader from "../../components/Loader";
import { useQuery } from "@tanstack/react-query";


export default function IncidentsFilterChart({
  setCurrentSlide,
  setTimeFilter,
  currentSlide,
  timeFilter,
  valuesType,
  siteChoices,
  setSelectedSite,
  selectedSite,
  quarterSelected,
  setQuarterSelected,
  selectedUser,
  setSelectedUser
}) {
  const { apiUrl } = useContext(AuthContext);
  const { t } = useTranslation();

const getUserHalo = async () => {
    const res = await axios.get(`${apiUrl}halo/get_users`, {
      withCredentials: true,
    });
    return res.data;
  };

  const { data: usersData, isLoading, isError } = useQuery({
    queryKey: ["userList"],
    enabled: currentSlide === "15",
    queryFn: getUserHalo,
  });

  const userChoices = usersData || [];

  return (
    <>
      <div className="page-section_form">
        <form className="form">
          <div className="form-input_container">
            <label htmlFor="type">{t('Type de graphique')}</label>
            <select
              className="only only_incidents"
              id="type"
              onChange={(e) => {
                setCurrentSlide(e.target.value);
              }}
              value={currentSlide}
            >
              {valuesType.map((item, index) => {
                return (
                  <option key={index} value={index}>
                    {t(item)}
                  </option>
                );
              })}
            </select>
          </div>
        </form>
        {userChoices.length > 0 && currentSlide === "15" && (
          <form className="form">
            <div className="form-input_container">
              <label htmlFor="users">{t('Sélectionnez un utilisateur')}</label>
              <select
                className="only only_incidents"
                id="users"
                onChange={(e) => setSelectedUser(e.target.value)}
                value={selectedUser}
              >
                <option value="">{t('Global')}</option>
                
                {userChoices.map((user, index) => {
                  const userName = user.name || user;
                  const userId = user.id || index;

                  return (
                    <option key={userId} value={userName}>
                      {userName}
                    </option>
                  );
                })}
              </select>
            </div>
          </form>
        )}
        {siteChoices.length > 0 && (currentSlide === "13" || currentSlide === "14") && (
          <form className="form">
            <div className="form-input_container">
              <label htmlFor="site">{t('Sélectionnez le site')}</label>
              <select
                className="only only_incidents"
                id="site"
                onChange={(e) => setSelectedSite(e.target.value)}
                value={selectedSite}
              >
                {siteChoices.map((site) => (
                  <option key={site} value={site}>
                    {site}
                  </option>
                ))}
              </select>
            </div>
          </form>
        )}
        {currentSlide !== "15" && (
          <form className="form">
            <div className="form-input_container">
              <label htmlFor="type">{t('Filtrer par')}</label>
              <select
                className="only only_incidents"
                id="type"
                onChange={(e) => {
                  setTimeFilter(e.target.value);
                }}
                value={timeFilter}
              >
                <option value="twelve">{t('Tickets des 12 derniers mois')}</option>
                <option value="months">{t('Tickets du mois')}</option>
                <option value="quarter">{t("Tickets du trimestre")}</option>
                <option value="all">{t('Tous les tickets')} </option>
              </select>
            </div>
          </form>
        )}
      </div>
      {timeFilter === "quarter" && (
        <div className="page-section_form">
          <form className="form">
            <div className="form-input_container">
              <label htmlFor="quarter">{t('Sélectionnez un trimestre')}</label>
              <select
                className="only only_incidents"
                id="quarter"
                onChange={(e) => setQuarterSelected(e.target.value)}
                value={quarterSelected}
              >
                <option value="1">{t('Premier trimestre')}</option>
                <option value="2">{t('Second trimestre')}</option>
                <option value="3">{t("Troisième trimestre")}</option>
                <option value="4">{t('Quatrième trimestre')} </option>
              </select>
            </div>
          </form>
        </div>
      )}
    </>
  );
}
